import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  ArrowLeft,
  Check,
  Sun,
  ArrowRight,
  CreditCard,
  Star,
  CalendarDays,
  Package,
  Truck
} from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './PackSelection.module.css';
import axios from 'axios';
import { subscribeUserApi, verifyOtpApi } from '../http/api';
import { v4 as uuidv4 } from 'uuid';
import {LanguageSwitcher} from '../components/LanguageSwitcher'
import { useTranslate } from '../components/UseTranslate';

const SUBSCRIPTION_PACKS = [
  {
    id: 'daily_sub',
    name: 'UVFOODBOX / Day',
    planLabel: 'DAILY PLAN',
    price: '60',
    duration: 'XAF / day',
    type: 'Subscription',
    servings: '1-2 SERVINGS',
    description: 'Discover fresh recipes every day',
    image: '/images/aesthetic.png',
    icon: CalendarDays
  },
  {
    id: 'weekly_sub',
    name: 'UVFOODBOX / Week',
    planLabel: 'WEEKLY PLAN',
    price: '300',
    duration: 'XAF / week',
    type: 'Subscription',
    servings: '4-5 SERVINGS',
    description: 'Unlock a full week of recipe inspiration',
    image: '/images/aesthetic.png',
    icon: Package
  },
  {
    id: 'onetime_daily',
    name: 'UVFOODBOX / Day',
    planLabel: 'DAILY PLAN',
    price: '70',
    duration: 'XAF / day',
    type: 'One-Time',
    servings: '1-2 SERVINGS',
    description: 'Explore recipes for one day',
    image: '/images/aesthetic.png',
    icon: Truck
  },
  {
    id: 'onetime_weekly',
    name: 'UVFOODBOX / Week',
    planLabel: 'WEEKLY PLAN',
    price: '350',
    duration: 'XAF / week',
    type: 'One-Time',
    servings: '4-5 SERVINGS',
    description: 'Enjoy recipes for an entire week',
    image: '/images/aesthetic.png',
    icon: Package
  }
];

function PackSelection() {
  const navigate = useNavigate();
  const { offerType: offerTypeParam } = useParams();
  const [selectedPack, setSelectedPack] = useState('subscription');

  const [loading,setLoading] = useState(false)

  const {t} = useTranslate()

  const location = useLocation();
  const msisdn = location?.state?.msisdn;
  const alias = location?.state?.alias;
  const packType = location?.state?.packType;
  console.log(location.state,'------------------')

  const ext_ref = localStorage.getItem('ext_ref')|| location.state?.ext_ref || uuidv4();


  const offerType =
    offerTypeParam === 'subscription'
      ? 'Subscription'
      : offerTypeParam === 'one time'
      ? 'One-Time'
      : '';

  

  console.log(selectedPack,'selected pack-------------')

  const handlePackSelect = (packId) => {
    setSelectedPack(packId);
  };

  const handleContinue =async () => {
    setLoading(true)
    if (selectedPack) {
      localStorage.setItem('selectedPack', selectedPack);
    }
    // navigate('/subscribe');

    try{

      // let {msisdn,otp,ext_ref,pack_type,purchase}=req.body;
      const data={
        msisdn:msisdn,
        alias:alias,
        ext_ref:ext_ref,
        pack_type:selectedPack.includes('daily') ? 'daily' : 'weekly',
        purchase:packType
      }

      const result = await axios.post(subscribeUserApi,data);
      
      console.log(result,'result-----------------')

      if(result.data.status == 1){
        
        setTimeout(()=>{
          toast.success('User Subscribed Successfully!!')
          setLoading(false)
          navigate('/confirm')
        },7000)
      }

      if(result.data.status == 0){
        toast.error(result?.data?.message || 'Some Error Occured');
         setTimeout(()=>{
          navigate('/subscribe')
        },1000)
      }
    }
    catch(error){
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Unable to verify OTP. Please try again.';
        setLoading(false)

     
      toast.error(error?.response?.data?.message ||
        error?.message ||
        'Unable to Subscribe. Please try again.')
       setTimeout(()=>{
          navigate('/subscribe')
        },1000)
    }

  };

  const filteredPacks = SUBSCRIPTION_PACKS.filter((p) => p.type === offerType);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.container}>
        <header className={styles.packTypeHeader}>
          <button className={styles.backBtn} onClick={() => navigate(-1)}>
            <ArrowLeft className={styles.backIcon} size={16} />
            <span>{t('Back')}</span>
          </button>

          <div className={styles.stepperContainer}>
            <div className={styles.stepper}>
              <div className={styles.stepConnector}>
                <div className={styles.connectorLineActive} />
              </div>

              <div className={`${styles.stepItem} ${styles.stepCompleted}`}>
                <div className={styles.stepCircle}>
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className={styles.stepTitle}>1. {t('Your Number')}</span>
              </div>

              <div className={`${styles.stepItem} ${styles.stepCompleted}`}>
                <div className={styles.stepCircle}>
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className={styles.stepTitle}>2. {t('OTP')}</span>
              </div>

              <div className={`${styles.stepItem} ${styles.stepActive}`}>
                <div className={styles.stepCircle}>
                  <Check size={14} strokeWidth={3} />
                </div>
                <span className={styles.stepTitle}>3. {t('Choose Pack')}</span>
              </div>

              <div className={styles.stepItem}>
                <div className={styles.stepCircle}>4</div>
                <span className={styles.stepTitle}>4. {t('Choose Plan')}</span>
              </div>
            </div>
          </div>
        </header>

        <section className={styles.heroSection}>
          <div className={styles.heroLeft}>
            <div className={styles.stepBadge}>
              <Sun size={14} className={styles.sunIcon} />
              <span>{t('STEP 2 OF 2')}</span>
            </div>
            <h1 className={styles.heroTitle}>
              <span className={styles.decorLeft}>✦</span>
              {t('Choose Your')} <span className={styles.highlightText}>{t('Recipe Collection')}</span>
              <span className={styles.decorRight}>✦</span>
            </h1>
            <p className={styles.heroSubtitle}>
              {t('Choose the perfect recipe plan and start cooking today.')}{' '}
              {offerTypeParam === 'subscription' ? 'recurring meal' : 'one-time order'} needs.
            </p>
          </div>
        </section>

        <div className={styles.packsContainer}>
          {filteredPacks.map((pack, index) => {
            const isSelected = selectedPack == pack.id;
            return (
              <motion.div
                key={pack.id}
                className={`${styles.packCard} ${isSelected ? styles.packCardSelected : ''}`}
                onClick={() => handlePackSelect(pack.id)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.99 }}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <div
                  className={styles.cardBackground}
                  style={{ backgroundImage: `url('${pack.image}')` }}
                />
                <div className={styles.cardOverlay} />

                <div className={styles.cardMain}>
                  <div className={styles.cardText}>
                    <div className={styles.cardHeaderRow}>
                      <div className={styles.planLabel}>{t(pack.planLabel)}</div>
                      <div className={styles.iconBadge}>
                        {pack.icon ? <pack.icon size={18} /> : <Star size={18} />}
                      </div>
                    </div>
                    <h3 className={styles.cardTitle}>{t(pack.name)}</h3>
                    <p className={styles.cardDescription}>{t(pack.description)}</p>
                  </div>

                  <div className={styles.cardFooterRow}>
                    <div className={styles.packDetails} >
                      <span className={styles.priceValue}>{pack.price}</span>
                      <span className={styles.priceUnit}>{t(pack.duration)}</span>
                    </div>
                    <button className={styles.selectButton} type="button" disabled={loading}>
                    {t('Select Plan')}
                      <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className={styles.bottomSection}>
          <motion.button
            className={styles.continueButton}
            onClick={handleContinue}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            disabled={loading}
          >
            <span>{loading ? t("subscribing...") : t('Continue')}</span>
            <ArrowRight className={styles.continueIcon} size={20} />
          </motion.button>
         
        </div>
        <ToastContainer />
      </div>
      <LanguageSwitcher/>
    </div>
  );
}

export default PackSelection;
